import { ScrollArea } from '@radix-ui/react-scroll-area';
import * as Select from '@radix-ui/react-select';

import { css, styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const SelectTrigger = styled(Select.Trigger)<{ $isBorderless: boolean; $isSmall: boolean }>`
  align-items: center;
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  gap: ${Spacing.Xxs};
  height: ${({ $isSmall }) => ($isSmall ? '2rem' : '3rem')};
  justify-content: space-between;
  padding: 0px ${Spacing.Xs};
  width: fit-content;

  span {
    font-size: ${({ $isSmall }) => ($isSmall ? '0.875rem' : '1rem')};
  }

  &[data-placeholder] span {
    color: ${({ $isBorderless }) => ($isBorderless ? Colors.black : Colors.gray[100])};
    font-size: ${({ $isSmall }) => ($isSmall ? '0.875rem' : '1rem')};
  }

  &:focus {
    outline: none;
  }

  svg {
    height: 1.5rem;
    width: 1.5rem;
  }

  ${({ $isBorderless, $isSmall }) =>
    $isBorderless &&
    css`
      border: none;

      gap: ${Spacing['3Xs']};
      justify-content: flex-start;
      padding: 0;

      span {
        font-size: ${$isSmall ? '0.75rem' : '1rem'};
        font-weight: 500;
      }

      &[data-placeholder] span {
        color: ${Colors.black};
        font-size: ${$isSmall ? '0.75rem' : '1rem'};
      }

      svg {
        height: 1rem;
        width: 1rem;
      }
    `}
`;

export const SelectContent = styled(Select.Content)`
  background: ${Colors.red};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  display: flex;
  flex-direction: column;
  max-height: 20rem;
  min-width: 14rem;
  width: var(--radix-select-trigger-width);
  z-index: 9999;
`;

export const ScrollAreaRoot = styled(ScrollArea)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive &&
    css`
      height: 24rem;
    `}
`;

export const SelectItem = styled(Select.Item)`
  align-items: center;
  background: ${Colors.white};
  cursor: pointer;
  display: flex;
  gap: ${Spacing.Xxs};
  height: 3rem;
  padding: 0 ${Spacing.Xs};

  &:hover {
    background: ${Colors.blue[5]};
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const RadioItem = styled.div<{ $isSelected: boolean }>`
  background: ${Colors.blue[5]};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Full};
  height: 1.5rem;
  min-width: 1.5rem;

  ${({ $isSelected }) =>
    $isSelected &&
    `
    border: 8px solid ${Colors.blue[100]};
  `}
`;
